import React from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import './Map.css';

// Fix for default marker icons in react-leaflet
delete (L.Icon.Default.prototype as any)._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

interface Location {
  address: string;
  city: string;
  postcode: string;
  coordinates: {
    latitude: number;
    longitude: number;
  };
}

interface MapProps {
  location: Location;
  zoom?: number;
}

const Map: React.FC<MapProps> = ({ location, zoom = 15 }) => {
  // Check if coordinates exist, otherwise use default coordinates
  const coordinates = location?.coordinates || { latitude: 0, longitude: 0 };
  const position: [number, number] = [
    coordinates.latitude,
    coordinates.longitude
  ];

  // If no valid coordinates, show a message instead of the map
  if (!location?.coordinates || (coordinates.latitude === 0 && coordinates.longitude === 0)) {
    return (
      <div className="map-container">
        <div style={{ 
          height: '100%', 
          width: '100%', 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center',
          backgroundColor: '#f5f5f5',
          color: '#666'
        }}>
          <p>Location coordinates not available</p>
        </div>
      </div>
    );
  }

  return (
    <div className="map-container">
      <MapContainer
        center={position}
        zoom={zoom}
        scrollWheelZoom={false}
        style={{ height: '100%', width: '100%' }}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <Marker position={position}>
          <Popup>
            <div>
              <strong>{location.address}</strong><br />
              {location.city}<br />
              {location.postcode}
            </div>
          </Popup>
        </Marker>
      </MapContainer>
    </div>
  );
};

export default Map; 